// extracted by mini-css-extract-plugin
export const postListItem = "index-module--postListItem--rWuKL";
export const home = "index-module--home--1mM2Q";